// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"

Rails.start()
ActiveStorage.start()

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector('#intgame') != null) {
    const gameBlock = document.querySelector('#intgame'),
    gameCards = gameBlock.querySelectorAll('.game-card'),
    tumbler = gameBlock.querySelector('.tumbler > input[type="checkbox"]');




    tumbler.addEventListener('change', (e) => {
        if (tumbler.checked) {
            gameCards.forEach(card => {
                card.classList.add('opened')
            })


        } else {
            gameCards.forEach(card => {
                card.classList.remove('opened')
            })
        }
    })


    gameCards.forEach(card => {
        card.addEventListener('click', (e) => {
            card.classList.toggle('opened')

            let opens = gameBlock.querySelectorAll('.game-card.opened').length
            if (opens == gameCards.length) {
                tumbler.checked = true
            } else {
                tumbler.checked = false
            }
        })
    })
  }

});

